/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {NbAclOptions} from '@nebular/security';
import {ROLE_MANAGER, ROLE_ADMIN, ROLE_SUPER_ADMIN} from 'compob2b-auth';


/**
 * ACL options for existing roles
 * @see {@link https://akveo.github.io/nebular/docs/security/acl-configuration--usage#acl-configuration}
 */
export const ACL_OPTIONS: NbAclOptions = {
  accessControl: {
    [ROLE_ADMIN]: {
      view: ['*', 'impersonate'],
      reindex: ['catalog_tree']
    },
    ROLE_IMPERSONATE: {
      view: ['*', 'impersonate']
    },
    [ROLE_MANAGER]: {
      view: ['logo'],
    },
    [ROLE_SUPER_ADMIN]: {
      parent: ROLE_ADMIN,
      create: ['unitGroup'],
      update: ['unitGroup'],
    },
  }
};
